import baseDocSubscriber from '../base-doc-subscriber';

export default function SubscribeUserSubscription({ environment, uid }) {
  return baseDocSubscriber(environment, 'userSubscriptions', uid);
}
